export { WishlistShareSectionDS } from './wishlist-share-section-ds'
export type { WishlistShareSectionDSProps } from './wishlist-share-section-ds.types'
